<template>
    <div class="d-inline-flex align-items-center flex-nowrap ps-1">
        <span
            v-if="numberOfContestantsHasChanged"
            v-html="
                $ti(
                    'externaldataupdate.numberofcontestants',
                    {
                        isonen: props.row.RaceContestantDetails.RelayTeamContestants.length,
                        existing: contestantStore.GetRelayContestants(props.row.RaceContestantDetails.ContestantID).length,
                    },
                    true,
                )
            "
        ></span>
        <span
            v-else-if="contestantsHasChanged"
            v-html="$tm('externaldataupdate.contestantdetailschanged', '', true)"
        ></span>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { RaceContestantDetailsExternalData } from '@/objects/RaceContestantDetailsExternalData';
import { useContestantStore } from '@/stores';
import { onMounted } from 'vue';
import { $ti } from '@/locize';

const props = defineProps<{
    /**
     * This is the race name from the source
     */
    value: string | null;

    /**
     * The full row object
     */
    row: RaceContestantDetailsExternalData;
}>();

const contestantStore = useContestantStore();

const numberOfContestantsHasChanged = ref<boolean>(false);

const contestantsHasChanged = ref<boolean>(false);

onMounted(() => {
    if (props.row?.RaceContestantDetails.RelayTeamName?.trim() !== '') {
        // // We get the existing relayTeamContestants
        const existingRelayTeamContestants = contestantStore.GetRelayContestants(props.row.RaceContestantDetails.ContestantID);

        if (existingRelayTeamContestants.length != props.row.RaceContestantDetails.RelayTeamContestants.length) {
            numberOfContestantsHasChanged.value = true;
        } else {
            // We need to check content
            const jsonExisting = JSON.stringify(
                existingRelayTeamContestants
                    .map((rc) => ({
                        Firstname: rc.Firstname,
                        Surname: rc.Surname,
                        LegNumber: rc.LegNumber,
                        Chip1: rc.Chip1,
                        Chip2: rc.Chip2,
                    }))
                    .sort((a, b) => (a.LegNumber ?? 0) - (b.LegNumber ?? 0)),
            );

            const jsonNew = JSON.stringify(
                props.row.RaceContestantDetails.RelayTeamContestants.map((rc) => ({
                    Firstname: rc.Firstname,
                    Surname: rc.Surname,
                    LegNumber: rc.LegNumber,
                    Chip1: rc.Chip1,
                    Chip2: rc.Chip2,
                })).sort((a, b) => (a.LegNumber ?? 0) - (b.LegNumber ?? 0)),
            );

            contestantsHasChanged.value = jsonExisting !== jsonNew;
        }
    }
});
</script>
